const SPARSE_DATA_QUERY_MAX_SIZE = 100000; // one hundred thousand

export default SPARSE_DATA_QUERY_MAX_SIZE;
